import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { RiDiscountPercentLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  freeOrder,
  getPendingOrders,
  RESETORDER,
  selectSuccessFreeOrder,
} from "../../redux/features/order/OrderSlice";

const FreeOrder = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [discountReason, setDiscountReason] = useState("");
  const dispatch = useDispatch();
  const isSuccess = useSelector(selectSuccessFreeOrder);

  const applyDiscount = async (e) => {
    e.preventDefault();

    if (!discountReason) {
      toast.error("Discount Reason is missing");
      return;
    }

    await dispatch(freeOrder({ id, discountReason }));
    dispatch(getPendingOrders());
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(RESETORDER());
      setIsOpen(false);
    }
  }, [dispatch, isSuccess]);

  return (
    <div>
      <button
        onClick={() => setIsOpen(true)}
        title="100% free Order"
        className="lg:px-3 px-2 py-2 bg-[#FFC107] text-white rounded-xl"
      >
        <RiDiscountPercentLine className="lg:size-6 size-[1.1rem]" />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white shadow-xl rounded-[10px] sm:w-[450px] w-[90%] mx-auto p-8 space-y-6">
            <div className="flex justify-between items-center border-b-2 border-[#DEDEDE] pb-2 mb-4">
              <h1 className="md:text-[1.2rem] text-[1rem] font-bold text-[#0D868C]">
                100% Discount
              </h1>
              <button type="button" onClick={() => setIsOpen(false)}>
                <FiX className="md:size-7 size-5 text-[#0D868C]" />
              </button>
            </div>

            <form onSubmit={applyDiscount}>
              <div className="mb-4 flex flex-col items-start">
                <label className="text-[.75rem] font-semibold text-[#7D7D7D]">
                  Discount Reason
                </label>
                <input
                  value={discountReason}
                  onChange={(e) => setDiscountReason(e.target.value)}
                  type="text"
                  placeholder="Discount reason"
                  className="w-full outline-none text-[1rem] font-normal text-[#A9A9A9] pr-3 pt-2 border-b border-[#0D868C]"
                />
              </div>

              <div className="text-center mt-8">
                <button
                  type="submit"
                  disabled={!discountReason}
                  className="text-white bg-[#0D868C] md:w-[50%] w-full py-3 rounded-full outline-none uppercase font-normal text-[1rem]"
                >
                  Apply Discount
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FreeOrder;
